<div id="facet-content">
  <div id="facet-options-holder">
    <nz-collapse nzExpandIconPosition="'right'">
      <nz-collapse-panel
        *ngFor="let panel of panels"
        class="facet-panel"
        [nzHeader]="panel.name"
        [(nzActive)]="panel.active"
        [nzDisabled]="false"
        (nzActiveChange)="onActiveChange()"
      >
        <div
          *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel)"
          class="facet-category-search"
        >
          <div class="facet-category-search-container">
            <div class="facet-category-searchbox">
              <nz-input-group nzSize="small" [nzPrefix]="prefixIcon">
                <input
                  nzSize="small"
                  class="facet-search-input category"
                  #inputElement
                  nz-input
                  type="text"
                  [placeholder]="placeholderValues[panel.key]"
                  [(ngModel)]="facetCategorySearch[panel.key]"
                  (keyup)="onFacetCategorySearch(panel)"
                />
              </nz-input-group>
              <ng-template #prefixIcon>
                <va-icon
                  size="small"
                  name="search"
                  class="search-icon"
                ></va-icon>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="facet-options-container">
          <ng-container *ngIf="!panel.isTree">
            <!-- loading panel with virtual scroll -->
            <ng-container *ngIf="panel.useVirtualScroll">
              <!-- loading state -->
              <div
                *ngIf="
                  loading &&
                  ((activePanel === panel.key && refreshCurrentPanel) ||
                    activePanel !== panel.key)
                "
              >
                <va-custom-skeleton
                  [customSkeletonConfig]="customSkeletonConfig"
                >
                </va-custom-skeleton>
              </div>
              <!--  populating panel data -->
              <div style="padding: 0 0 0 12px">
                <cdk-virtual-scroll-viewport
                  *ngIf="
                    !loading ||
                    (activePanel == panel.key && !refreshCurrentPanel)
                  "
                  itemSize="19"
                  class="virtual-scroll"
                >
                  <nz-list [nzSplit]="false">
                    <nz-list-item
                      [nzNoFlex]="false"
                      *cdkVirtualFor="let item of facetData[panel.key]"
                    >
                      <label
                        nz-checkbox
                        [ngModel]="cachedSelections[panel.key][item.value]"
                        (ngModelChange)="onOptionChange(panel.key, item)"
                        [nzDisabled]="panel['showCount'] && item['count'] == 0"
                        title="{{
                          panel.key === 'ticker'
                            ? item['fullname']
                            : item['isAlias']
                              ? item['label'] + 'alias: ' + item['alias']
                              : item['label']
                        }}"
                        class="option base-level-option"
                      >
                        <span>{{ item["label"] }}</span>
                        <span *ngIf="panel['showCount']" class="count">
                          ({{ item["count"] }})
                        </span>
                        <span *ngIf="item['isAlias']" style="padding-left: 8px"
                          >alias: {{ item["alias"] }}</span
                        >
                      </label>
                    </nz-list-item>
                  </nz-list>
                </cdk-virtual-scroll-viewport>
              </div>
            </ng-container>

            <!-- loading panel without virtual scroll -->
            <ng-container *ngIf="!panel.useVirtualScroll">
              <!-- loading state -->
              <div
                *ngIf="
                  loading &&
                  ((activePanel === panel.key && refreshCurrentPanel) ||
                    activePanel !== panel.key)
                "
              >
                <va-custom-skeleton
                  [customSkeletonConfig]="customSkeletonConfig"
                >
                </va-custom-skeleton>
              </div>
              <!-- populating panel data -->
              <div
                *ngIf="
                  !loading || (activePanel == panel.key && !refreshCurrentPanel)
                "
                class="real-scroll-panel-is-not-tree"
              >
                <ng-container *ngFor="let item of facetData[panel.key]">
                  <label
                    nz-checkbox
                    [ngModel]="cachedSelections[panel.key][item.value]"
                    (ngModelChange)="onOptionChange(panel.key, item)"
                    [nzDisabled]="panel['showCount'] && item['count'] == 0"
                    title="{{
                      panel.key === 'ticker' ? item['fullname'] : item['label']
                    }}"
                  >
                    <span class="option">{{ item["label"] }}</span>
                    <span *ngIf="panel['showCount']" class="count"
                      >({{ item["count"] }})</span
                    >
                  </label>
                </ng-container>
                <ng-container *ngIf="panel.key === 'phase'">
                  <nz-divider style="margin: 0px !important"></nz-divider>
                  <div class="include-terminated">
                    <label style="padding-right: 6px">Include Terminated</label>
                    <nz-switch
                      nzSize="small"
                      [(ngModel)]="facetFilter['include_terminated']"
                      (ngModelChange)="onSwitchChange($event)"
                    ></nz-switch>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="panel.isTree">
            <!-- loading state -->
            <div
              *ngIf="
                loading &&
                ((activePanel === panel.key && refreshCurrentPanel) ||
                  activePanel !== panel.key)
              "
            >
              <va-custom-skeleton [customSkeletonConfig]="customSkeletonConfig">
              </va-custom-skeleton>
            </div>
            <!-- loading tree without virtual scroll -->
            <ng-container *ngIf="!panel.useVirtualScroll">
              <div
                *ngIf="
                  !loading || (activePanel == panel.key && !refreshCurrentPanel)
                "
                class="real-scroll-panel-is-tree"
              >
                <nz-tree
                  class="facet-tree"
                  [nzData]="facetData[panel.key]"
                  nzCheckable
                  nzMultiple
                  [nzSelectedKeys]="cachedSelections[panel.key]"
                  [nzCheckedKeys]="cachedSelections[panel.key]"
                  (nzCheckBoxChange)="
                    onHierarchyOptionChange(panel.key, $event)
                  "
                  (nzExpandChange)="onExpandChange($event, panel)"
                  [nzTreeTemplate]="nzTreeTemplate"
                  nzHideUnMatched
                  [nzSearchValue]="
                    facetCategorySearch[panel.key] &&
                    facetCategorySearch[panel.key].trim().length >= 3
                      ? facetCategorySearch[panel.key].trim()
                      : ''
                  "
                ></nz-tree>
              </div>
            </ng-container>
            <!-- loading tree with virtual scroll -->
            <ng-container *ngIf="panel.useVirtualScroll">
              <!-- <cdk-virtual-scroll-viewport
                *ngIf="
                  !loading || (activePanel == panel.key && !refreshCurrentPanel)
                "
                itemSize="19"
                class="virtual-scroll"
              > -->
              <div
                *ngIf="
                  !loading || (activePanel == panel.key && !refreshCurrentPanel)
                "
              >
                <nz-tree
                  class="facet-tree virtual-scroll"
                  [nzData]="facetData[panel.key]"
                  nzCheckable
                  nzMultiple
                  nzBlockNode
                  nzVirtualHeight="280px"
                  nzVirtualItemSize="30"
                  nzVirtualMinBufferPx="300"
                  nzVirtualMaxBufferPx="370"
                  [nzSelectedKeys]="cachedSelections[panel.key]"
                  [nzCheckedKeys]="cachedSelections[panel.key]"
                  (nzCheckBoxChange)="
                    onHierarchyOptionChange(panel.key, $event)
                  "
                  (nzExpandChange)="onExpandChange($event, panel)"
                  [nzTreeTemplate]="nzTreeTemplate"
                  nzHideUnMatched
                  [nzSearchValue]="
                    facetCategorySearch[panel.key] &&
                    facetCategorySearch[panel.key].trim().length >= 3
                      ? facetCategorySearch[panel.key].trim()
                      : ''
                  "
                ></nz-tree>
              </div>
              <!-- </cdk-virtual-scroll-viewport> -->
            </ng-container>

            <ng-template #nzTreeTemplate let-node>
              <div class="tree-option-container">
                <span
                  title="{{ node['title'] }}"
                  [ngClass]="
                    node.isLeaf
                      ? 'child-option'
                      : 'level' + node.level.toString()
                  "
                  class="option"
                  >{{ node["title"] }}</span
                >
                <span
                  *ngIf="panel['showCount']"
                  class="count"
                  title="{{ node['title'] }}"
                  >({{ node.origin["count"] }})</span
                >
              </div>
            </ng-template>
          </ng-container>
        </div>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
</div>
